module.exports = __webpack_public_path__ + "img/zhenghuang.6ffc18eb.png";